import { render, staticRenderFns } from "./TTransporterOrderCard.vue?vue&type=template&id=f6624122&scoped=true&"
import script from "./TTransporterOrderCard.vue?vue&type=script&lang=js&"
export * from "./TTransporterOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./TTransporterOrderCard.vue?vue&type=style&index=0&id=f6624122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6624122",
  null
  
)

/* custom blocks */
import block0 from "./TTransporterOrderCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports